module.exports = __webpack_public_path__ + "1bb0de211eb24e2d48a21e68f0001772.png";